import React, { FC, PropsWithChildren } from "react";
import { Box, Stack } from "@mui/material";
import Header from "@components/Header/Header";
import Footer from "@components/Footer/Footer";
import styled from "@emotion/styled";
import { useScrollFix } from "@hooks/useScrollFix";

const Content = styled.div`
  display: flex;
  box-sizing: border-box;
  flex: 1;
  gap: 20px;
  flex-direction: column;
`;

const OnboardingLayout: FC<PropsWithChildren<any>> = ({ children }) => {
  const scrollRef = useScrollFix();

  return (
    <Stack ref={scrollRef} width="100%" height="100%" overflow="auto">
      <Header onboardingMode={true} />
      <Content>
        <Box minHeight="64px" />
        {children}
      </Content>
      <Footer />
    </Stack>
  );
};

export default OnboardingLayout;
